export interface PlacePredictionDto {
  placeId?: string;
  description?: string;
}
